import {
  AiOutlineArrowRight,
} from "react-icons/ai";

import { Link } from "react-router-dom";

const OurStores = () => {


  const customerNotice26 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement_thumbnail.jpg"
  const customerNotice25 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve_thumbnail.png"
  const customerNotice24 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency_thumbnail.png"
  const customerNotice27 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Notice-post-settlement-thumbnail.png"
  const customerNotice28 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20thumbnail-1.jpg.jpeg"
  const customerNotice29 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20settlement%20thumbnail.png"
  const customerNotice30 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20thumbnail-1.jpg%20(1).jpeg"
  const customerNotice32 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20it%20ad%20paper%20thumbnail.jpg.jpeg"
  const customerNotice33 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20MPR%20thumbnail.jpg.jpeg"
  const customerNotice34 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20KYC%20thumbnail.jpg.jpeg"
  const customerNotice35 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20cheque%20thumbnail.png"
  const customerNotice36 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20it%20ad%20paper%20thumbnail1.jpeg"
  const customerNotice37 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/12_08_26_IZB_ad_thumbnail.jpg"
  const customerNotice38 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0825_IZB_works_bid_ad.jpg"
  const customerNotice39 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20ad%20thumbnail%201.jpg.jpeg"
  const customerNotice40 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20ad%20thumbnailss.jpeg"

  return (
    <section>
      <div className="container notice-and-announcements">
        <div className="row">
          <div className="container">
            <div className="heading py-2">
              <h2 className="text-center">Notice / Announcements</h2>
              {/* <p className="text-center">All News And Updates</p> */}
            </div>
            <div
              className="py-4 read-more-flot-btn"
            // style={{ float: "right"}}
            >
              <Link
                to="/NoticeAnnouncements"
                className="text-white rounded px-3 py-1"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                See More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0729_IZB%20works%20bid%20ad.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice40} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0729_IZB%20works%20bid%20ad.pdf" target="_blank" rel="noreferrer">INVITATION TO TENDER FOR FITOUT WORKS AT LEVY MWANAWASA BRANCH</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>September 17, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank (IZB) intends to undertake Fitout works at Levy Mwanawasa Branch, located at Levy Mwanawasa University, Lusaka and hereby invites sealed bids from eligible contractors registered with the National Council for Construction (NCC) in Grade 3 and 4 to submit bids for the proposed works.
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0729_IZB%20works%20bid%20ad.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0911_IZB%20properties%20copy.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice39} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0911_IZB%20properties%20copy.pdf" target="_blank" rel="noreferrer">INVITATION TO BID: SALE OF PROPERTIES (MORTGAGEE IN POSSESSION)</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>September 15, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank Limited as mortgagees in possession is inviting bids from interested parties for purchase of the following properties on "as is where is basis". Interested parties may purchase the bidding Document/Form upon payment of a non-refundable fee of ZMW500...
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0911_IZB%20properties%20copy.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0825_IZB_works_bid_ad.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice38} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0825_IZB_works_bid_ad.pdf" target="_blank" rel="noreferrer">TENDER CLOSING DATE EXTENSION: CHILANGA AND NAKONDE BRANCH WORKS...</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>August 26, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank hereby notifies all prospective bidders that the tender closing date for the Refurbishment Works at Chilanga Branch and Fit-Out Works at the Proposed Nakonde Branch has been extended from 26th August 2026 to 31st August 2026.
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0825_IZB_works_bid_ad.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurStores;
